import React, { useEffect, useState } from "react";
import HeaderLayout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { approveExpenseReport } from "@services/expense-reports.service";
import { getValue } from "@utils/lodash";
import {
  approveExpenseReportLogin,
  approveTriptLogin,
  getSpecificTripLogin,
  rejectTriptLogin,
} from "@services/common.service";
import { toast } from "react-toastify";
import GearLoader from "@components/common/GearLoader";
import { useNavigate } from "react-router-dom";
import ConfirmTripReportPopup from "./TripReportPopUp";
import { getSpecificTrip } from "@services/trips.service";

function TripReject(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  const params = useParams();

  const [message, setMessage] = useState<any>("");
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  useEffect(() => {
    getTripData();
  }, []);

  const getTripData = async () => {
    let resp:any = await getSpecificTripLogin(
      getValue(params, `id`, ""),
      getValue(urlParams, `token`, "")
    );
    if (resp?.data?.approval_status === "awaiting_approval") {
      setShowConfirmPopup(true);
    } else {
      setMessage(
        "An action has already been executed on this trip; kindly log in to review it."
      );
    }
  };

  const getData = async () => {
    try {
      let resp = await rejectTriptLogin(
        getValue(params, `id`, ""),
        getValue(urlParams, `token`, "")
      );
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setMessage(getValue(resp, `message`, ""));
        setShowConfirmPopup(false);
      }
    } catch (error) {
      setMessage(error);
      setShowConfirmPopup(false);
    }
  };
  return (
    <HeaderLayout>
      {/* <div className=" d-flex align-items-center justify-content-center mt-5">
        
        <h6 className="header_text__18">Trip Rejected Successfully</h6>
      </div> */}
      <ConfirmTripReportPopup
        isOpen={showConfirmPopup}
        handleApproveReject={getData}
        handleCancelModal={() => {
          setShowConfirmPopup(false);
        }}
        type={"reject the trip"}
        commentsRequired={false}
      />
      <div className="d-flex h-100 w-100 align-items-center justify-content-center">
        <div className="not-found-wrapper d-flex w-100 align-items-center justify-content-center new-not-found-wrapper">
          <div className="not-found-wrapper__details text-center">
            <img
              src="/images/notfound/trips-not-found.svg"
              className="not-found-image img-fluid trips-image"
            />
            <p className="header_text__19 text-center not-found-text">
              {message}
              <br />
              <span></span>
            </p>
          </div>
        </div>
      </div>
    </HeaderLayout>
  );
}

export default TripReject;
